/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersAddComponent
 * Purpose		: This component allows to create new Shippers record and save changes.
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { ShippersData, ShippersService } from './Shippers.service';


@Component({
	selector: 'my-Shippers-add',
	template: require('./ShippersAdd.component.html'),
	providers: [ShippersService
		
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ShippersAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objShippers: ShippersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private ShippersService: ShippersService

	) {
		this.objShippers = new ShippersData();
	}

	ngOnInit() {
		this.objShippers = new ShippersData();
		this.getLookups();
	}

	addShippers() {
		this.ShippersService.addShippersData(this.objShippers)
			.subscribe(record => this.router.navigate(['/Shippers']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('Shippers record added successfully...', 'Add Shippers');
				console.log('Shippers record added successfully...'); 
			}
		);
	}

	gotoShippers() {
		// let Id = this.objShippers ? this.objShippers.ShipperID : null;
		this.router.navigate(['/Shippers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Shippers/ShippersAdd.component.ts